import React, { useState, useEffect } from "react";
import useQuery from "../../hook/useQuery";
import {
    Link as RouterLink,
    useHistory,
    useLocation,
    useParams,
} from "react-router-dom";
import { toast } from "react-toastify";
import {
    Grid,
    Box,
    Typography,
    Button,
    TextField,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Modal,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Link,
    Checkbox,
    OutlinedInput,
    Tabs,
    Tab,
    Divider,
    FormHelperText,
    IconButton,
} from "@material-ui/core";
import Search from "@material-ui/icons/Search";

import EmpresaService from "../../services/empresaService";
import usuarioService from "../../services/usuarioService";
import useStyles from "./style";
import { useAuth } from "../../auth/ProvideAuth";

import PropTypes from "prop-types";
import TableUsuarios from "../../components/TableUsuarios";
import {} from "react-router-dom/cjs/react-router-dom.min";
import { unstable_batchedUpdates } from "react-dom";
import UsuarioService from "../../services/usuarioService";
import MaskUtils from "../../utils/maskUtils";
import ModalUsuarios from "../../components/ModalUsuarios";
import ModalPoliticas from "../../components/ModalPoliticas";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import TableEmpresaPoliticas from "../../components/TableEmpresaPoliticas";
import PoliticaService from "../../services/politicaService";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const Cadastro = () => {
    const params = useParams();
    const [intervalLoop, setIntervalLoop] = useState(true);
    const location = useLocation();
    const [abrirModal, setAbrirModal] = useState(false);
    const [abrirPoliticaModal, setAbrirPoliticaModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingPolitica, setLoadingPolitica] = useState(false);
    const redirect_rel = location.state ? location.state.redirect_rel : null;

    const auth = useAuth();

    const history = useHistory();
    const classes = useStyles();

    const [campoBuscar, setCampoBuscar] = useState("");
    const query = useQuery();

    const [error, setErro] = useState({ isError: false, erroMsg: "" });
    const [nome, setNome] = useState("");
    const [razao, setRazao] = useState("");
    const [cnpj, setCnpj] = useState("");

    const [nomeError, setNomeErro] = useState({ isError: false, erroMsg: "" });
    const [razaoError, setRazaoErro] = useState({
        isError: false,
        erroMsg: "",
    });
    const [cnpjError, setCnpjErro] = useState({ isError: false, erroMsg: "" });
    const [estadoError, setEstadoErro] = useState({
        isError: false,
        erroMsg: "",
    });
    const [cepError, setCepErro] = useState({ isError: false, erroMsg: "" });
    const [dddError, setDddErro] = useState({ isError: false, erroMsg: "" });

    const [endereco, setEndereco] = useState("");
    const [complemento, setComplemento] = useState("");
    const [numero, setNumero] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("SC");
    const [cep, setCep] = useState("");

    const [ddd, setDDD] = useState("");
    const [telefone, setTelefone] = useState("");
    const [inscricao, setInscricao] = useState("");

    const [tipoCobranca, setTipoCobranca] = useState("");
    const [saldo, setSaldo] = useState(0);
    const [site, setSite] = useState("");
    const [checked, setChecked] = useState("");
    let showPassword = true;
    const fecharModal = (e) => {
        setAbrirModal(false);
    };

    const fecharPoliticaModal = (e) => {
        setAbrirPoliticaModal(false);
    };
    const changeUserValue = {
        buscar: (value) => setCampoBuscar(value),
    };

    const handleChange = async (event) => {
        const key = event.target.name;
        const value = event.target.value;

        if (key && changeUserValue[key]) {
            changeUserValue[key](value);
            let paramns = getJsonFilter();
            paramns[key] = value;
            await buscarUsuarios(params.id, paramns.buscar);
        }
    };

    const changeStatus = () => {
        setChecked(!checked);
    };

    const emptyError = () => {
        setErro({ isError: false, erroMsg: "" });
    };

    const searchCep = async (cep) => {
        if (cep != "" && cep.length == 8) {
            setCepErro({ isError: false });
            await EmpresaService.buscarCep(cep)
                .then((res) => {
                    if (res.city) {
                        setCidade(res.city);
                    }
                    if (res.state) {
                        setEstado(res.state);
                    }
                    if (res.neighborhood) {
                        setBairro(res.neighborhood);
                    }
                    if (res.street) {
                        setEndereco(res.street);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err.code === "ECONNABORTED") {
                        setCepErro({
                            isError: true,
                            erroMsg: "Serviço indisponivel no momento",
                        });
                        return "timeout";
                    }
                    setCepErro({
                        isError: true,
                        erroMsg: "CEP não encontrado!",
                    });
                });
        } else {
            setCepErro({ isError: true, erroMsg: "CEP deve conter 8 dígitos" });
        }
    };

    const setEmpresa = async (id) => {
        await EmpresaService.buscarEmpresa(id)
            .then((result) => {
                unstable_batchedUpdates(() => {
                    setNome(result.nome_fantasia);
                    setRazao(result.razao_social);
                    setCnpj(MaskUtils.cnpjMask(result.cnpj));
                    setInscricao(result.ie);

                    setEndereco(result.endereco);
                    setComplemento(result.complemento);
                    setNumero(result.numero);
                    setBairro(result.bairro);
                    setCidade(result.cidade);
                    setEstado(result.estado);
                    setCep(result.cep);

                    setDDD(result.ddd);
                    setTelefone(result.telefone);
                    setSite(result.site);

                    setChecked(result.ind_ativo);
                    setTipoCobranca(result.tipo_cobranca)
                    setSaldo(result.saldo_credito)
                });
            })
            .catch((err) => {
                toast.error(err.detail, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                history.push(`/empresas`);
            });
    };

    const buscarUsuariosPorEmpresa = async (empresaId) => {
        let paramns = getJsonFilter();

        await buscarUsuarios(parseInt(params.id), paramns.buscar, paramns.page);
    };


    useEffect(async () => {
        let paramns = getJsonFilter();
        if (params.id != undefined) {
            await setEmpresa(params.id);
            buscarUsuariosPorEmpresa(params.id);
            // await buscarPoliticas(paramns.buscar, paramns.page)
            await buscarEmpresaPoliticas(params.id)
            
        }
    }, []);

    const resetFields = () => {
        setCnpjErro({ isError: false });
        setRazaoErro({ isError: false });
        setNomeErro({ isError: false });
        setCepErro({ isError: false });
        setEstadoErro({ isError: false });
        setDddErro({ isError: false });
    };

    const validarCampos = () => {
        resetFields();

        let isError = false;

        if (cnpj == "" || cnpj == undefined) {
            setCnpjErro({ isError: true, erroMsg: "CNPJ é obrigatório" });
            isError = true;
        }

        if (cnpj != "" && cnpj.replace(/\D/g, "").length != 14) {
            setCnpjErro({
                isError: true,
                erroMsg: "CNPJ deve conter 14 dígitos",
            });
            isError = true;
        }

        if (razao == "" || razao == undefined) {
            setRazaoErro({
                isError: true,
                erroMsg: "Razão Social é obrigatório",
            });
            isError = true;
        }

        if (nome == "" || nome == undefined) {
            setNomeErro({
                isError: true,
                erroMsg: "Nome Fantasia é obrigatório",
            });
            isError = true;
        }

        if (cep != "" && cep.length != 8) {
            setCepErro({ isError: true, erroMsg: "CEP deve conter 8 dígitos" });
            isError = true;
        }

        if (estado != "" && estado.length != 2) {
            setEstadoErro({
                isError: true,
                erroMsg: "UF deve conter apenas 2 dígitos",
            });
            isError = true;
        }

        if (ddd != "" && (ddd.length < 2 || ddd.length > 3)) {
            setDddErro({
                isError: true,
                erroMsg: "DDD deve conter 2 ou 3 dígitos",
            });
            isError = true;
        }

        if (isError) return false;

        return true;
    };

    const saveEmpresa = async () => {
        let tipo = 0
        if (tipoCobranca != "")
            tipo = parseInt(tipoCobranca)
            
        let empresa = {
            "id": parseInt(params.id) || null,
            "razao_social": razao,
            "nome_fantasia": nome,
            "cnpj": cnpj.replace(/\D/g, ""),
            "endereco": endereco,
            "numero": numero,
            "complemento": complemento,
            "bairro": bairro,
            "cidade": cidade,
            "estado": estado,
            "cep": cep,
            "ddd": ddd,
            "telefone": telefone,
            "ie": inscricao,
            "site": site,
            "ind_ativo": checked,
            "tipo_cobranca": tipo,
            "saldo_credito": parseFloat(saldo)
        }

        if (validarCampos()) {
            if (params.id != undefined) {
                const response = await EmpresaService.atualizarEmpresa(empresa)
                    .then(() => {
                        toast.success("Empresa Atualizada com Sucesso!", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });

                        emptyError();
                    })
                    .catch((e) => {
                        setErro({ isError: true });
                        toast.error(e.detail, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    });
            } else {
                const response = await EmpresaService.cadastrarEmpresa(empresa)
                    .then((data) => {
                        toast.success("Empresa Cadastrada com Sucesso!", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        history.push(`cadastro/${data.id}`);
                        setChecked(true);
                        emptyError();
                    })
                    .catch((e) => {
                        setErro({ isError: true });
                        toast.error(e.detail, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    });
            }
        }
    };

    const [usuarios, setUsuarios] = useState([]);
    const [politicas, setPoliticas] = useState([]);
    const [pagina, setPagina] = useState(1);
    const [paginaPolitica, setPaginaPolitica] = useState(1);
    const [limite, setLimite] = useState(10);
    const [total, setTotal] = useState(0);
    const [totalPolitica, setTotalPolitica] = useState(0);
    const configPortal = usuarioService.getConfigPortal();
    const camposListagem = configPortal?.campos_listagem
        ? configPortal.campos_listagem
        : [];

    const espacoListagem = configPortal?.espaco_listagem
        ? configPortal.espaco_listagem
        : 12;

    const [value, setValue] = React.useState(0);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };

    const getJsonFilter = () => {
        return {
            buscar: "",
            page: "",
            id: "",
        };
    };

    const buscarUsuarios = async (
        id = undefined,
        busca = "",
        page = undefined,
        interval = false
    ) => {
        if (!interval) {
            setIntervalLoop(false);
        }

        const paginaRequest = page ? page : 1;
        setPagina(paginaRequest);

        const result = await UsuarioService.buscarTodosPorEmpresaId(
            id,
            paginaRequest,
            limite,
            busca
        );

        setUsuarios(result.usuarios);
        setTotal(result.total);
        if (!interval) {
            setIntervalLoop(true);
        }
    };

    const buscarEmpresaPoliticas = async (
        id = undefined,
        interval = false
    ) => {
        if (!interval) {
            setIntervalLoop(false);
        }

        // const paginaRequest = page ? page : 1;
        setPaginaPolitica(1);

        const result = await PoliticaService.buscarPorEmpresa(id);

        setPoliticas(result.politicas);
        setTotalPolitica(result.total)
        if (!interval) {
            setIntervalLoop(true);
        }
    };

    const handleChangePage = async (event, newPage) => {
        let paramns = getJsonFilter();
        if (params.id != undefined) {
            await buscarUsuarios(params.id, paramns.buscar, newPage + 1);
        }
    };

    const handleChangePoliticaPage = async (event, newPage) => {
        let paramns = getJsonFilter();
        if (params.id != undefined) {
            // await buscarPoliticas(paramns.buscar, newPage + 1);
            await buscarEmpresaPoliticas(params.id);
        }
    };

    return (
        <>
            <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
            >
                <Box marginTop="2rem" width="80rem" maxWidth="95vw">
                    <h3>Cadastro de Empresa</h3>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                            value={value}
                            onChange={handleChangeTab}
                            aria-label="basic tabs example"
                        >
                            <Tab label="Dados" {...a11yProps(0)} />
                            <Tab
                                disabled={params.id == undefined}
                                label="Usuários"
                                {...a11yProps(1)}
                            />
                            <Tab
                                disabled={params.id == undefined}
                                label="Politicas"
                                {...a11yProps(2)}
                            />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        {/* INFORMAÇÕES */}
                        <Divider component="div" align="center">
                            Informações
                        </Divider>

                        <Grid container className={classes.margin}>
                            <Grid item xs={12}>
                                <Grid
                                    container
                                    spacing={3}
                                    alignItems="baseline"
                                >
                                    <Grid item md={3} xs={12}>
                                        <div className={classes.margin}>
                                            <TextField
                                                error={cnpjError.isError}
                                                helperText={cnpjError.erroMsg}
                                                size="small"
                                                label="CNPJ"
                                                variant="outlined"
                                                type="text"
                                                fullWidth={true}
                                                value={cnpj}
                                                onChange={(e) =>
                                                    setCnpj(e.target.value)
                                                }
                                            />
                                        </div>
                                    </Grid>

                                    <Grid item md={9} xs={12}>
                                        <TextField
                                            error={razaoError.isError}
                                            helperText={razaoError.erroMsg}
                                            size="small"
                                            label="Razão Social"
                                            variant="outlined"
                                            type="text"
                                            fullWidth={true}
                                            value={razao}
                                            onChange={(e) =>
                                                setRazao(e.target.value)
                                            }
                                        />
                                    </Grid>
                                    <Grid item md={9} xs={12}>
                                        <TextField
                                            error={nomeError.isError}
                                            helperText={nomeError.erroMsg}
                                            size="small"
                                            label="Nome Fantasia"
                                            variant="outlined"
                                            type="text"
                                            fullWidth={true}
                                            value={nome}
                                            onChange={(e) =>
                                                setNome(e.target.value)
                                            }
                                        />
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <TextField
                                            size="small"
                                            label="Inscrição Estadual"
                                            variant="outlined"
                                            type="text"
                                            fullWidth={true}
                                            value={inscricao}
                                            onChange={(e) =>
                                                setInscricao(e.target.value)
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* ENDEREÇO */}

                        <Divider
                            className={classes.margin}
                            component="div"
                            align="center"
                        >
                            Endereço
                        </Divider>

                        <Grid container className={classes.margin}>
                            <Grid item xs={12}>
                                <Grid
                                    container
                                    spacing={3}
                                    alignItems="baseline"
                                    className={classes.margin}
                                >
                                    <Grid item md={2} xs={12}>
                                        <FormControl
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error={cepError.isError}
                                        >
                                            <InputLabel htmlFor="outlined-cep-search">
                                                CEP
                                            </InputLabel>
                                            <OutlinedInput
                                                id="outlined-cep-search"
                                                type="text"
                                                value={cep}
                                                onChange={(e) =>
                                                    setCep(e.target.value)
                                                }
                                                error={cepError.isError}
                                                helperText={cepError.erroMsg}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={(e) =>
                                                                searchCep(cep)
                                                            }
                                                            edge="end"
                                                        >
                                                            <Search />
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                                label="CEP"
                                            />
                                            <FormHelperText>
                                                {cepError.erroMsg}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    {/* OKAY */}
                                    <Grid item md={9} xs={12}>
                                        <TextField
                                            size="small"
                                            label="Logradouro"
                                            variant="outlined"
                                            type="text"
                                            fullWidth={true}
                                            value={endereco}
                                            onChange={(e) =>
                                                setEndereco(e.target.value)
                                            }
                                        />
                                    </Grid>
                                    <Grid item md={1} xs={12}>
                                        <TextField
                                            size="small"
                                            label="Número"
                                            variant="outlined"
                                            type="text"
                                            fullWidth={true}
                                            value={numero}
                                            onChange={(e) =>
                                                setNumero(e.target.value)
                                            }
                                        />
                                    </Grid>
                                    <Grid item md={8} xs={12}>
                                        <TextField
                                            size="small"
                                            label="Complemento"
                                            variant="outlined"
                                            type="text"
                                            fullWidth={true}
                                            value={complemento}
                                            onChange={(e) =>
                                                setComplemento(e.target.value)
                                            }
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            size="small"
                                            label="Bairro"
                                            variant="outlined"
                                            type="text"
                                            fullWidth={true}
                                            value={bairro}
                                            onChange={(e) =>
                                                setBairro(e.target.value)
                                            }
                                        />
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <TextField
                                            size="small"
                                            label="Cidade"
                                            variant="outlined"
                                            type="text"
                                            fullWidth={true}
                                            value={cidade}
                                            onChange={(e) =>
                                                setCidade(e.target.value)
                                            }
                                        />
                                    </Grid>
                                    <Grid item md={1} xs={12}>
                                        <FormControl
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        >
                                            <Select
                                                size="small"
                                                variant="outlined"
                                                value={estado}
                                                onChange={(e) =>
                                                    setEstado(e.target.value)
                                                }
                                                name="estado"
                                                displayEmpty
                                                className={classes.selectEmpty}
                                            >
                                                <MenuItem value="">UF</MenuItem>
                                                <MenuItem value={"AC"}>
                                                    AC
                                                </MenuItem>
                                                <MenuItem value={"AL"}>
                                                    AL
                                                </MenuItem>
                                                <MenuItem value={"AP"}>
                                                    AP
                                                </MenuItem>
                                                <MenuItem value={"AM"}>
                                                    AM
                                                </MenuItem>
                                                <MenuItem value={"BA"}>
                                                    BA
                                                </MenuItem>
                                                <MenuItem value={"CE"}>
                                                    CE
                                                </MenuItem>
                                                <MenuItem value={"DF"}>
                                                    DF
                                                </MenuItem>
                                                <MenuItem value={"ES"}>
                                                    ES
                                                </MenuItem>
                                                <MenuItem value={"GO"}>
                                                    GO
                                                </MenuItem>
                                                <MenuItem value={"MA"}>
                                                    MA
                                                </MenuItem>
                                                <MenuItem value={"MT"}>
                                                    MT
                                                </MenuItem>
                                                <MenuItem value={"MS"}>
                                                    MS
                                                </MenuItem>
                                                <MenuItem value={"MG"}>
                                                    MG
                                                </MenuItem>
                                                <MenuItem value={"PA"}>
                                                    PA
                                                </MenuItem>
                                                <MenuItem value={"PB"}>
                                                    PB
                                                </MenuItem>
                                                <MenuItem value={"PR"}>
                                                    PR
                                                </MenuItem>
                                                <MenuItem value={"PE"}>
                                                    PE
                                                </MenuItem>
                                                <MenuItem value={"PI"}>
                                                    PI
                                                </MenuItem>
                                                <MenuItem value={"RJ"}>
                                                    RJ
                                                </MenuItem>
                                                <MenuItem value={"RN"}>
                                                    RN
                                                </MenuItem>
                                                <MenuItem value={"RS"}>
                                                    RS
                                                </MenuItem>
                                                <MenuItem value={"RO"}>
                                                    RO
                                                </MenuItem>
                                                <MenuItem value={"RR"}>
                                                    RR
                                                </MenuItem>
                                                <MenuItem value={"SC"}>
                                                    SC
                                                </MenuItem>
                                                <MenuItem value={"SP"}>
                                                    SP
                                                </MenuItem>
                                                <MenuItem value={"SE"}>
                                                    SE
                                                </MenuItem>
                                                <MenuItem value={"TO"}>
                                                    TO
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs>
                                {/*  CONTATO  */}

                                <Divider
                                    className={classes.margin}
                                    component="div"
                                    align="center"
                                >
                                    Contato
                                </Divider>

                                <Grid container className={classes.margin}>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            spacing={3}
                                            alignItems="baseline"
                                            className={classes.margin}
                                        >
                                            <Grid item md={8} xs={12}>
                                                <TextField
                                                    size="small"
                                                    label="Site"
                                                    variant="outlined"
                                                    type="text"
                                                    fullWidth={true}
                                                    value={site}
                                                    onChange={(e) =>
                                                        setSite(e.target.value)
                                                    }
                                                />
                                            </Grid>
                                            <Grid item md={4}></Grid>
                                            <Grid item md={2} xs={12}>
                                                <TextField
                                                    error={dddError.isError}
                                                    helperText={
                                                        dddError.erroMsg
                                                    }
                                                    size="small"
                                                    label="DDD"
                                                    variant="outlined"
                                                    type="text"
                                                    fullWidth={true}
                                                    value={ddd}
                                                    onChange={(e) =>
                                                        setDDD(e.target.value)
                                                    }
                                                />
                                            </Grid>
                                            
                                            <Grid item md={6} xs={12}>
                                                <TextField
                                                    size="small"
                                                    label="Telefone"
                                                    variant="outlined"
                                                    type="text"
                                                    fullWidth={true}
                                                    value={telefone}
                                                    onChange={(e) =>
                                                        setTelefone(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </Grid>
                                            {params.id != undefined && (
                                                <FormControl
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                >
                                                    <Grid item md={6} xs={12}>
                                                        Ativo
                                                        <Checkbox
                                                            checked={checked}
                                                            onChange={
                                                                changeStatus
                                                            }
                                                            name="setChecked"
                                                            value={checked}
                                                        />
                                                    </Grid>
                                                </FormControl>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs>
                                {/* COMPLEMENTAR */}

                                <Divider
                                    className={classes.margin}
                                    component="div"
                                    align="center"
                                >
                                    Informações Complementares
                                </Divider>

                                <Grid container className={classes.margin}>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            spacing={3}
                                            alignItems="baseline"
                                            className={classes.margin}
                                        >
                                            <Grid item md={4} xs={12}>
                                                <FormControl
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                >
                                                    <Select
                                                        size="small"
                                                        variant="outlined"
                                                        value={tipoCobranca}
                                                        onChange={(e) =>
                                                            setTipoCobranca(
                                                                e.target.value
                                                            )
                                                        }
                                                        name="tipoCobranca"
                                                        displayEmpty
                                                        className={
                                                            classes.selectEmpty
                                                        }
                                                    >
                                                        <MenuItem value="">
                                                            Tipo de Cobrança
                                                        </MenuItem>
                                                        <MenuItem value={0}>
                                                            Pré-Pago
                                                        </MenuItem>
                                                        <MenuItem value={1}>
                                                            Pós-Pago
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            {/* <Grid item md={4} xs={12}>
                                                <TextField
                                                    inputProps={{
                                                        inputMode: "numeric",
                                                    }}
                                                    size="small"
                                                    label="Valor da Cobrança"
                                                    variant="outlined"
                                                    type="number"
                                                    fullWidth={true}
                                                    value={cobranca}
                                                    onChange={(e) =>
                                                        setCobranca(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </Grid> */}

                                            <Grid item md={4} xs={12}>
                                                <TextField
                                                    inputProps={{
                                                        inputMode: "numeric",
                                                        // pattern: "[0-9]*",
                                                    }}
                                                    size="small"
                                                    label="Saldo Crédito"
                                                    variant="outlined"
                                                    type="number"
                                                    step="0.01"
                                                    fullWidth={true}
                                                    value={saldo}
                                                    onChange={(e) =>
                                                        setSaldo(e.target.value)
                                                    }
                                                />
                                            </Grid>

                                            
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CustomTabPanel>

                    {/* PAINEL DE USUARIOS */}

                    <CustomTabPanel value={value} index={1}>
                        <Grid item xs={12}>
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Grid item md={2} xs={12}>
                                    <TextField
                                        label="Buscar"
                                        fullWidth
                                        variant="outlined"
                                        type="text"
                                        size="small"
                                        value={campoBuscar}
                                        name="buscar"
                                        onChange={handleChange}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    {/* TODO: NOVO USUÁRIO */}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={(e) => setAbrirModal(true)}
                                    >
                                        Novo Usuário
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Box
                            marginTop="1.5rem"
                            width="80rem"
                            maxWidth="95vw"
                            marginBottom="1rem"
                            minHeight="40rem"
                        >
                            <TableUsuarios
                                rows={usuarios}
                                pagina={pagina - 1}
                                limite={limite}
                                empresaId={params.id}
                                empresa={nome}
                                total={total}
                                buscarUsuarios={buscarUsuarios}
                                camposListagem={camposListagem}
                                padding={espacoListagem}
                                handleChangePage={handleChangePage}
                            />
                        </Box>
                        {/* MODAL */}
                        <Modal
                            open={abrirModal}
                            onClose={fecharModal}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                        >
                            <Grid>
                                <ModalUsuarios
                                    fecharModal={fecharModal}
                                    loading={loading}
                                    empresaId={params.id}
                                    empresa={nome}
                                    buscarUsuarios={buscarUsuarios}
                                />
                            </Grid>
                        </Modal>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <Grid item xs={12}>
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Grid item md={2} xs={12}>

                                </Grid>
                            <Grid item>
                                    {/* TODO: NOVO POLITICA */}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={(e) => setAbrirPoliticaModal(true)}
                                    >
                                        Adicionar Política
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    <Box
                            marginTop="1.5rem"
                            width="80rem"
                            maxWidth="95vw"
                            marginBottom="1rem"
                            minHeight="40rem"
                        >
                            <TableEmpresaPoliticas
                                rows={politicas}
                                pagina={pagina - 1}
                                limite={limite}
                                empresaId={params.id}
                                empresa={nome}
                                total={totalPolitica}
                                buscarPoliticas={buscarEmpresaPoliticas}
                                camposListagem={camposListagem}
                                padding={espacoListagem}
                                handleChangePage={handleChangePoliticaPage}
                            />
                        </Box>
                        {/* MODAL */}
                        <Modal
                            open={abrirPoliticaModal}
                            onClose={fecharPoliticaModal}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                        >
                            <Grid>
                                <ModalPoliticas
                                    fecharModal={fecharPoliticaModal}
                                    loading={loadingPolitica}
                                    empresaId={params.id}
                                    empresa={nome}
                                    politicasAtuais={politicas}
                                    buscarPoliticas={buscarEmpresaPoliticas}
                                />
                            </Grid>
                        </Modal>
                    </CustomTabPanel>
                </Box>
                <Box marginTop="2rem" width="80rem" maxWidth="95vw">
                    {params.id != undefined ? (
                        <Button
                            onClick={saveEmpresa}
                            type="submit"
                            variant="contained"
                            color="primary"
                        >
                            Atualizar
                        </Button>
                    ) : (
                        <Button
                            onClick={saveEmpresa}
                            type="submit"
                            variant="contained"
                            color="primary"
                        >
                            Salvar
                        </Button>
                    )}
                </Box>
            </Grid>
        </>
    );
};

export default Cadastro;
